<template>
  <div id="app" class="container-fluid">
  <b-row >
    <b-col cols="12" class="header">
      <img alt="Contexity" src="./assets/contexity-logo-white.png" class="logo float-right">
      <h1><img alt="Chatinator" src="./assets/chatinator.png" class="clogo" v-on:click.prevent="reset"> Chatinator</h1>
    </b-col>
    </b-row>

    <Chatinator/>

  </div>
</template>
<script>
import Chatinator from './components/Chatinator.vue'

export default {
  name: 'App',
  components: {
    Chatinator
  },
  methods: {
    reset() {
      this.$store.commit('updateDialog', '');
    },
  }
}
</script>

<style lang="scss">
  @import '@/styles/custom.scss';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #2c3e50;
  }

  .logo {
    max-width: 200px;
  }
  .header {
    padding-top: 40px;
    padding-bottom: 40px;
    height: 160px;
    margin-bottom: 20px;
    background-color: #29424d;
  }
  .header h1 {
    color: #fff;
    font-family: "Maven Pro";
    font-size: 3rem;
  }
  .header .subtitle {
    color: #fff;
    font-family: "Maven Pro";
    font-weight: 300;
    font-size: 1.6rem;
    line-height: 16px;
    margin-left: 1rem;
  }
  .clogo {
    max-height: 80px;
    margin-bottom: 10px;
  }
</style>
